import ConvexUvBufferGeometry from "oc-threejs/geometries/ConvexUvBufferGeometry";
import Jaco3d from "./Jaco3d";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import Textures from "oc-threejs/Textures";

export default class ConvexPlate3d extends Jaco3d.Mixin(THREE.Mesh) {

    constructor(brett) {
        super(brett);
    }

    update3d() {
        this.copyCoordinateSystem(this.jaco);
        const verticesChanged = this.changed('vertices');
        const materialChanged = this.changed('material');
        if (verticesChanged) {
            this.updateGeometry();
        }
        if (materialChanged) {
            this.updateMaterial();
        }
    }

    updateGeometry() {
        if (!this.jaco.box || this.jaco.box.isEmpty()) {
            console.error('a ConvexPlate must not have zero volume', this.box);
            throw new Error('a ConvexPlate must not have zero volume');
        }
        this.geometry = new ConvexUvBufferGeometry(this.jaco.vertices,this.jaco.getBasis());
    }

    updateMaterial() {
        const material = this.jaco.material || UniversalLoader.getMaterialFactory().create(this.jaco.materialKey);
        Textures.setMaterialWithRandomOffsetInto({
            material,
            target: this,
            textureOffsetRandom: this.textureOffsetRandom
        });
    }

}
